import { render, staticRenderFns } from "./VisitCreate.vue?vue&type=template&id=64bffd48&scoped=true"
import script from "./VisitCreate.vue?vue&type=script&lang=js"
export * from "./VisitCreate.vue?vue&type=script&lang=js"
import style0 from "./VisitCreate.vue?vue&type=style&index=0&id=64bffd48&prod&scoped=true&lang=scss"
import style1 from "./VisitCreate.vue?vue&type=style&index=1&id=64bffd48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bffd48",
  null
  
)

export default component.exports